import {
  SVGArrowLeft as SVGArrowLeftComponent,
  SVGArrowRight as SVGArrowRightComponent,
} from "@/lib/svg";
import LinkComponent from "next/link";
import { useRouter } from "next/router";
import { Button as ButtonStyled, Container } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const SVGArrowLeft = SVGArrowLeftComponent as any;
const SVGArrowRight = SVGArrowRightComponent as any;
const Link = LinkComponent as any;
const Button = ButtonStyled as any;

export type PaginationProps = {
  page: number;
  nbPages: number;
};

const Pagination: React.FC<PaginationProps> = (props) => {
  const { page, nbPages } = props;
  const { query } = useRouter();

  const prevPage = page - 1;
  const nextPage = page + 1;

  const hasNextPage = page < nbPages;
  const hasPrevPage = page >= 1;

  return (
    <Container>
      {hasPrevPage ? (
        <Link
          passHref
          href={{
            query: {
              ...query,
              page: prevPage,
            },
          }}
        >
          <Button icon={<SVGArrowLeft />}>Prev</Button>
        </Link>
      ) : (
        <div></div>
      )}
      {hasNextPage && (
        <Link
          passHref
          href={{
            query: {
              ...query,
              page: nextPage,
            },
          }}
        >
          <Button icon={<SVGArrowRight />}>Next</Button>
        </Link>
      )}
    </Container>
  );
};

export default Pagination;
